import { Goods } from "redux/constants/Goods";

const initState = {
  data: [],
  loading: false,
};

const goods = (state = initState, action) => {
  switch (action.type) {
    case Goods.LOADING_GOODS_LIST:
      return {
        ...state,
        loading: action.payload,
      };
    case Goods.GET_GOODS_LIST:
      return {
        ...state,
        data: action.payload,
      };
    default:
      return state;
  }
};

export default goods;